import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import Cards1 from './../block/Cards1'
import Kontakti from './../block/Kontakti'

class Akcii extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <Cards1
          list={data?.akcii?.list || []}
          title={data?.pagetitle || ``}
          margin={`top-17`}
          cols={`2`}
          layout={12}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Akcii.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Akcii.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Akcii